// components/Tasks/FilteringRules/constants.js

export const OPERATORS = {
  text: [
    "equals",
    "contains", 
    "not_contains",
    "contains_any_row",
    "not_contains_any_row",
    "is_not_empty",
  ],
  number: [
    "equals",
    "greater_than",
    "less_than",
    "between",
  ],
  bool: [
    "is_true",
    "is_false",
  ],
  date: [
    "between",
    "less_than",      // Before
    "greater_than",   // After
  ],
};

export const OPERATOR_LABELS = {
  equals: "Equals",
  contains: "Contains",
  not_contains: "Not contains",
  contains_any_row: "Contains any row",
  not_contains_any_row: "Not contains any row",
  is_not_empty: "Is not empty",
  greater_than: "Greater than",
  less_than: "Less than",
  between: "Between",
  is_true: "Is true",
  is_false: "Is false",
};

export const DATE_OPERATOR_LABELS = {
  between: "Between",
  less_than: "Before",
  greater_than: "After",
};

export const OPERATOR_ICONS = {
  equals: "=",
  contains: "∈",
  not_contains: "∉",
  contains_any_row: "⊇",
  not_contains_any_row: "⊉",
  is_not_empty: "∃",
  greater_than: ">",
  less_than: "<",
  between: "↔",
  is_true: "✓",
  is_false: "✗",
};

export const NO_VALUE_OPERATORS = ["is_not_empty", "is_true", "is_false"];

export const getOperatorsByType = (type) => OPERATORS[type] || OPERATORS.text;

export const getOperatorLabel = (type, operator) => {
  if (type === "date" && DATE_OPERATOR_LABELS[operator]) {
    return DATE_OPERATOR_LABELS[operator];
  }
  return OPERATOR_LABELS[operator] || operator;
};